var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "settingModule" },
    [
      _c("em", [_vm._v("Webshop settings")]),
      _c(
        "transition",
        { attrs: { name: "slide-fade", duration: { enter: 500, leave: 0 } } },
        [
          _c(
            "div",
            [
              _c("hr"),
              _c("p", { staticClass: "tagGroupName" }, [
                _vm._v("Default view"),
              ]),
              _c("div", [
                _c("label", { staticClass: "container" }, [
                  _vm._v(" Grid "),
                  _c("input", {
                    attrs: { type: "radio", name: "view" },
                    domProps: {
                      checked: _vm.settingsModule.defaultView == "grid",
                    },
                    on: {
                      click: function ($event) {
                        _vm.settingsModule.defaultView = "grid"
                      },
                    },
                  }),
                  _c("span", { staticClass: "checkmark22" }),
                ]),
                _c("label", { staticClass: "container" }, [
                  _vm._v(" List "),
                  _c("input", {
                    attrs: { type: "radio", name: "view" },
                    domProps: {
                      checked: _vm.settingsModule.defaultView == "list",
                    },
                    on: {
                      click: function ($event) {
                        _vm.settingsModule.defaultView = "list"
                      },
                    },
                  }),
                  _c("span", { staticClass: "checkmark22" }),
                ]),
              ]),
              _c("em", [_vm._v("The default view for webshop products.")]),
              _c("hr"),
              _c("div", [
                _c("label", { staticClass: "container" }, [
                  _vm._v(" Use global value "),
                  _c("input", {
                    attrs: { type: "radio", name: "Image-view" },
                    domProps: {
                      checked:
                        _vm.settingsModule.imageView == _vm.globalflaptype,
                    },
                    on: {
                      click: function ($event) {
                        _vm.settingsModule.imageView = _vm.globalflaptype
                      },
                    },
                  }),
                  _c("span", { staticClass: "checkmark22" }),
                ]),
                _c("label", { staticClass: "container" }, [
                  _vm._v(" Image with mortar "),
                  _c("input", {
                    attrs: { type: "radio", name: "Image-view" },
                    domProps: { checked: _vm.settingsModule.imageView == "M" },
                    on: {
                      click: function ($event) {
                        _vm.settingsModule.imageView = "M"
                      },
                    },
                  }),
                  _c("span", { staticClass: "checkmark22" }),
                ]),
                _c("label", { staticClass: "container" }, [
                  _vm._v(" Image without mortar "),
                  _c("input", {
                    attrs: { type: "radio", name: "Image-view" },
                    domProps: { checked: _vm.settingsModule.imageView == "NM" },
                    on: {
                      click: function ($event) {
                        _vm.settingsModule.imageView = "NM"
                      },
                    },
                  }),
                  _c("span", { staticClass: "checkmark22" }),
                ]),
              ]),
              _c("em", [_vm._v("Image view with mortar or without mortar")]),
              !this.$root.dynamiccatpage ? _c("hr") : _vm._e(),
              !this.$root.dynamiccatpage ? _c("hr") : _vm._e(),
              !this.$root.dynamiccatpage
                ? _c("div", [
                    _c("label", { staticClass: "container" }, [
                      _vm._v(" Show Filter "),
                      _c("input", {
                        attrs: { type: "checkbox", name: "filter" },
                        domProps: {
                          checked: _vm.settingsModule.showFilter == true,
                        },
                        on: {
                          click: function ($event) {
                            _vm.settingsModule.showFilter =
                              !_vm.settingsModule.showFilter
                          },
                        },
                      }),
                      _c("span", { staticClass: "checkbox" }),
                    ]),
                  ])
                : _vm._e(),
              !this.$root.dynamiccatpage
                ? _c("em", [_vm._v("Show sorting filter")])
                : _vm._e(),
              !this.$root.dynamiccatpage ? _c("hr") : _vm._e(),
              !this.$root.dynamiccatpage
                ? _c(
                    "transition",
                    {
                      attrs: {
                        name: "slide-fade",
                        duration: { enter: 500, leave: 0 },
                      },
                    },
                    [
                      this.settingsModule.showFilter == false &&
                      _vm.categories.length != 0
                        ? _c(
                            "div",
                            [
                              _vm._l(
                                _vm.categories,
                                function (category, index) {
                                  return _c(
                                    "div",
                                    { key: index },
                                    [
                                      _c("p", { staticClass: "tagGroupName" }, [
                                        _vm._v(_vm._s(category.attribute)),
                                      ]),
                                      _vm._l(
                                        category.values,
                                        function (value, index2) {
                                          return _c("div", { key: index2 }, [
                                            _c(
                                              "label",
                                              { staticClass: "container" },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(value.name) + " "
                                                ),
                                                _c("input", {
                                                  staticClass: "myBox",
                                                  attrs: {
                                                    type: "checkbox",
                                                    name: "attr",
                                                  },
                                                  domProps: {
                                                    checked: value.checked,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      value.checked =
                                                        !value.checked
                                                    },
                                                  },
                                                }),
                                                _c("span", {
                                                  staticClass: "checkbox",
                                                }),
                                              ]
                                            ),
                                          ])
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                }
                              ),
                              _c("hr"),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "button",
        {
          staticClass: "saveRelationsBtn",
          attrs: { disabled: this.$parent.saving },
          on: { click: _vm.saveSettings },
        },
        [
          this.$parent.saving
            ? _c(
                "svg",
                {
                  staticClass: "fontAwesomeIcon white iconSpin",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z",
                    },
                  }),
                ]
              )
            : _c(
                "svg",
                {
                  staticClass: "fontAwesomeIcon white",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z",
                    },
                  }),
                ]
              ),
          _vm._v(" Save "),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }